import { render, staticRenderFns } from "./AINumberPicker.vue?vue&type=template&id=0889f964&scoped=true"
import script from "./AINumberPicker.vue?vue&type=script&lang=js"
export * from "./AINumberPicker.vue?vue&type=script&lang=js"
import style0 from "./AINumberPicker.vue?vue&type=style&index=0&id=0889f964&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0889f964",
  null
  
)

export default component.exports